import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';

import { useAppContext } from '@prisjakt/ui-app-context';

import { H3Text } from '@prisjakt/ui/text/variants';
import { NavigationSliceView } from 'src/areas/product-collection/components/navigation/navigation-component';

import { Section } from './styles';

import { TabAnchor } from '../navigation/types';
import { Brand, Maybe } from 'src/types';
import { FacetLink } from 'src/areas/product-collection/components/navigation/types';

type Props = {
  brands: Maybe<Omit<Brand, 'media'>>[];
  count: number;
};

export const BrandResults = (props: Props) => {
  const { brands, count } = props;

  const { t } = useAppContext();
  const history = useHistory();

  const formattedLinks: FacetLink[] = useMemo(
    () =>
      brands?.map(brand => {
        const link = {
          id: brand?.id.toString() || '',
          value: brand?.name || '',
          selected: false,
          path: brand?.pathName,
          imageUrl: brand?.brandLogo || undefined,
          indexable: true,
        };

        return link;
      }) ?? [],
    [brands]
  );

  return brands?.length ? (
    <Section id={TabAnchor.BRANDS}>
      <H3Text>{`${t('search', 'brands.title')} (${count})`}</H3Text>

      <NavigationSliceView
        links={formattedLinks}
        onClick={(link: FacetLink) => {
          if (link.path) {
            history.push(link.path);
            // trackSearchResultBrandClicked(link.id, link.value);
          }
        }}
      />
    </Section>
  ) : null;
};
